module.exports = __webpack_public_path__ + "img/m2.0774f851.svg";